module.exports = __webpack_public_path__ + "static/media/Doula.a5123079.svg";